export default function Hero() {
  return (
    <section id="hero">
      <div className="hero-bg"></div>
      <div className="hero-grain"></div>

      <div className="hero-content">
        <div className="hero-eyebrow">
          Hyderabad's Most Affordable Event Planners
        </div>

        <h1 className="hero-h1">ARCH &amp;</h1>

        <span className="hero-h1-em">Crown</span>

        <div className="hero-rule"></div>

        <p className="hero-sub">
          Beautiful events shouldn't cost a fortune. We craft unforgettable
          celebrations — weddings, birthdays, corporate events and more —
          at prices every family can feel good about.
        </p>

        <div className="hero-btns">
          <a href="#contact" className="btn-primary">
            Plan Your Event
          </a>

          <a href="#events" className="btn-ghost">
            Explore What We Do
          </a>
        </div>
      </div>

      <div className="hero-scroll">
        <div className="scroll-label">Scroll</div>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}